import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GiantModule } from './layout/admin-layout/giant-modules/giant.module';
import { giantConfig } from './layout/admin-layout/config';
import { GiantSharedModule } from './layout/admin-layout/shared/GiantSharedModule';
import { GiantSidebarModule } from './layout/admin-layout/sidebar/sidebar.module';
import { MainLayoutModule } from './layout/admin-layout/main-layout.module';
import { LoaderService } from './layout/admin-layout/services/loader-service';
import { LoaderInterceptor } from './layout/admin-layout/services/http-interceptor';
import { LoaderComponent } from './layout/admin-layout/components/spinner/loader.component';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GiantSnackBarService } from './shared/utils/giant-snack-bar';
import { UserRepository } from './repositories/user/UserRepository';



@NgModule({
    declarations: [AppComponent,LoaderComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        HttpClientModule,
        MatProgressSpinnerModule,

        // Material
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        // Giant modules
        GiantModule.forRoot(giantConfig),
        GiantSharedModule,
        GiantSidebarModule,
        MainLayoutModule
    ],
    providers: [
        LoaderService,
        GiantSnackBarService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
      ],
    bootstrap: [AppComponent]
})
export class AppModule { }
